import { SR_API_ACTION_GET_TOUR_HEALTH } from 'api/actionTypes';
import typeCheck from 'common/util/typeCheck';

export default async function getTourHealth(
  { state, apiClient },
  { listingId, forceRefresh = false },
) {
  listingId = parseInt(listingId, 10);
  if (!listingId) {
    return;
  }
  typeCheck('listingId::PositiveNumber', listingId);

  const statePath = ['listingTourHealth', listingId];
  if (state.exists(statePath) && !forceRefresh) {
    return state.get(statePath);
  }

  const tourHealth = await apiClient.postWithState({
    action: SR_API_ACTION_GET_TOUR_HEALTH,
    state: state,
    payload: {
      listingId: listingId,
    },
    onSuccess(tourHealth) {
      state.set(statePath, tourHealth);
    },
  });

  return tourHealth;
}
